import { authFetch } from "../../../../../api/api";


const BASE_URL = (process.env.REACT_APP_DJANGO_BACKEND || "").replace(/\/+$/, "");
const SUPPLIER_PREPAYMENTS_URL = `${BASE_URL}/api/accounting/supplier-prepayments/`;
const SUPPLIER_PREPAYMENT_DOCS_URL = `${BASE_URL}/api/accounting/supplier-prepayment-documents/`;
const SUPPLIERS_URL = `${BASE_URL}/api/suppliers/suppliers/`;
const ALLOCATIONS_URL = `${BASE_URL}/api/accounting/allocations/`;
const ORDERS_URL = `${BASE_URL}/api/orders/`;
const CURRENCIES_URL = `${BASE_URL}/api/accounting/currencies/`;

export async function getAllSupplierPrepayments(supplierId) {
  const url = supplierId
    ? `${SUPPLIER_PREPAYMENTS_URL}?supplier=${supplierId}`
    : SUPPLIER_PREPAYMENTS_URL;
  const response = await authFetch(url);
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}

export async function getAllSuppliers() {
  const response = await authFetch(SUPPLIERS_URL);
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}

export async function getAllAllocations() {
  const response = await authFetch(ALLOCATIONS_URL);
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}

export async function getAllOrders() {
  const response = await authFetch(ORDERS_URL);
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}

export async function getAllCurrencies() {
  const response = await authFetch(CURRENCIES_URL);
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}

export async function createSupplierPrepayment(payload) {
  const response = await authFetch(SUPPLIER_PREPAYMENTS_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

export async function patchSupplierPrepayment(id, patch) {
  const response = await authFetch(`${SUPPLIER_PREPAYMENTS_URL}${id}/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

export async function deleteSupplierPrepayment(id) {
  const response = await authFetch(`${SUPPLIER_PREPAYMENTS_URL}${id}/`, {
    method: "DELETE",
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  return { ok: true };
}

export async function uploadSupplierPrepaymentDocument(prepaymentId, file) {
  const fd = new FormData();
  fd.append("files", file);
  const response = await authFetch(
    `${SUPPLIER_PREPAYMENTS_URL}${prepaymentId}/documents/`,
    { method: "POST", body: fd }
  );
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

export async function deleteSupplierPrepaymentDocument(docId) {
  const response = await authFetch(`${SUPPLIER_PREPAYMENT_DOCS_URL}${docId}/`, {
    method: "DELETE",
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  return { ok: true };
}